import React, { memo } from 'react';
import { formatPace } from '../../utils/formatters';
import { useStopwatchContext } from '../../contexts';

// Remove props interface as values now come from context
// interface PaceIndicatorsProps {
//   lastSegmentPace: number | null;
//   currentLapPace: number | null;
// }

// Update component signature to not require props
const PaceIndicators: React.FC = memo(() => {
  // Get pace values directly from context
  const { paceUnit, lastSegmentPace, lastCompletedLapPace } = useStopwatchContext();

  return (
    <div className="workout__pace-container">
      {/* Last Segment Pace Indicator */}
      <div
        className={`workout__pace-indicator workout__pace-indicator--segment ${lastSegmentPace ? '' : 'workout__pace-indicator--empty'}`}
      >
        {/* Use lastSegmentPace from context */}
        <div className="workout__pace-value">{formatPace(lastSegmentPace, paceUnit)}</div>
        <div className="workout__pace-label">Last Segment Pace</div>
      </div>

      {/* Last Lap Pace Indicator */}
      <div
        className={`workout__pace-indicator workout__pace-indicator--lap ${lastCompletedLapPace ? '' : 'workout__pace-indicator--empty'}`}
      >
        {/* Use lastCompletedLapPace from context instead of currentLapPace */}
        <div className="workout__pace-value">{formatPace(lastCompletedLapPace, paceUnit)}</div>
        <div className="workout__pace-label">Last Lap Pace</div>
      </div>
    </div>
  );
});

// Add display name
PaceIndicators.displayName = 'PaceIndicators';

export default PaceIndicators;
